import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { Bucket } from "../../enum/jobEnums";
import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { changeCandidateStatus } from "../services/candidate.services";
import { ReviewCandidateResponse } from "../types/candidate.types";

interface UseChangeCandidateStatusParams {
  jobId: number | string;
  candidateId: number | string;
}

export const useChangeCandidateStatus = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("goHire", { keyPrefix: "components.candidateStatus" });

  return useMutation<ReviewCandidateResponse, Error, UseChangeCandidateStatusParams & { payload: { bucket: Bucket } }>({
    mutationFn: ({ jobId, candidateId, payload }) => changeCandidateStatus({ jobId, candidateId, payload }),
    onSuccess: (_, { jobId, candidateId }) => {
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.candidates(String(jobId)) });
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.jobDetails(String(jobId)) });
      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.topMatchedApplicants(String(jobId)) });

      queryClient.invalidateQueries({ queryKey: GO_HIRE_QUERY_KEYS.candidateApplication(jobId, candidateId) });

      toast.success(t("candidateStatusChangedSuccessfully"));
    },
  });
};
